module.exports = __webpack_public_path__ + "img/labourday2015-2.758bd0d4.jpg";